module.exports = __webpack_public_path__ + "static/media/chatbot_blink.8f3e1b2c.svg";